import Vue from 'vue';
import Router from 'vue-router'
import Index from '@/components/pages/Index';
import article1 from '@/components/pages/articles/article1';
import article2 from '@/components/pages/articles/article2';
import article3 from '@/components/pages/articles/article3';

import Helpers from '@/tools/Helpers';
Vue.use(Router);


const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [
        {
            path: '/',
            name: 'index',
            component: Index,
            beforeEnter: (to, from, next) => {
                Helpers.ga().send('send','pageview','/');
                next();
            }
        },
        {
            path: '/main',
            name: 'main',
            component: Index,
            beforeEnter: (to, from, next) => {
                Helpers.ga().send('send','pageview','/main');
                next();
            }
        },
        {
            path: '/point1',
            name: 'point1',
            component: Index,
            beforeEnter: (to, from, next) => {
                Helpers.ga().send('send','pageview','/point1');
                next();
            }
        },
        {
            path: '/point2',
            name: 'point2',
            component: Index,
            beforeEnter: (to, from, next) => {
                Helpers.ga().send('send','pageview','/point2');
                next();
            }
        },
        {
            path: '/point3',
            name: 'point3',
            component: Index,
            beforeEnter: (to, from, next) => {
                Helpers.ga().send('send','pageview','/point3');
                next();
            }
        },
        {
            path: '/point4',
            name: 'point4',
            component: Index,
            beforeEnter: (to, from, next) => {
                Helpers.ga().send('send','pageview','/point4');
                next();
            }
        },
        {
            path: '/point5',
            name: 'point5',
            component: Index,
            beforeEnter: (to, from, next) => {
                Helpers.ga().send('send','pageview','/point5');
                next();
            }
        },
        {
            path: '/picnic',
            name: 'picnic',
            component: Index,
            beforeEnter: (to, from, next) => {
                Helpers.ga().send('send','pageview','/picnic');
                next();
            }
        },
        {
            path: '/article1',
            name: 'article1',
            component: article1,
            beforeEnter: (to, from, next) => {
                Helpers.ga().send('send','pageview','/article1');
                next();
            }
        },
        {
            path: '/article2',
            name: 'article2',
            component: article2,
            beforeEnter: (to, from, next) => {
                Helpers.ga().send('send','pageview','/article2');
                next();
            }
        },
        {
            path: '/article3',
            name: 'article3',
            component: article3,
            beforeEnter: (to, from, next) => {
                Helpers.ga().send('send','pageview','/article3');
                next();
            }
        }
    ]
});



export default router;



// WEBPACK FOOTER //
// ./src/router/index.js